import React from 'react';
import { useTranslation } from 'react-i18next';

const ErrorContent = ({ error, errorInfo, onReset }) => {
  const { t } = useTranslation();

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      padding: '20px',
      textAlign: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white'
    }}>
      <h1 style={{ fontSize: '48px', marginBottom: '20px' }}>⚠️</h1>
      <h2 style={{ fontSize: '24px', marginBottom: '10px' }}>{t('errorBoundary.title')}</h2>
      <p style={{ fontSize: '16px', marginBottom: '30px', opacity: 0.9 }}>
        {t('errorBoundary.description')}
      </p>
      <button
        onClick={onReset}
        style={{
          padding: '12px 24px',
          fontSize: '16px',
          backgroundColor: 'white',
          color: '#667eea',
          border: 'none',
          borderRadius: '8px',
          cursor: 'pointer',
          fontWeight: 'bold',
          transition: 'transform 0.2s'
        }}
        onMouseOver={(e) => e.target.style.transform = 'scale(1.05)'}
        onMouseOut={(e) => e.target.style.transform = 'scale(1)'}
      >
        {t('errorBoundary.goHome')}
      </button>
      {process.env.NODE_ENV === 'development' && error && (
        <details style={{
          marginTop: '30px',
          padding: '20px',
          backgroundColor: 'rgba(0,0,0,0.2)',
          borderRadius: '8px',
          maxWidth: '800px',
          textAlign: 'left'
        }}>
          <summary style={{ cursor: 'pointer', marginBottom: '10px' }}>{t('errorBoundary.errorDetails')}</summary>
          <pre style={{
            overflow: 'auto',
            fontSize: '12px',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
          }}>
            {error.toString()}
            {errorInfo?.componentStack}
          </pre>
        </details>
      )}
    </div>
  );
};

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContent
          error={this.state.error}
          errorInfo={this.state.errorInfo}
          onReset={() => {
            this.setState({ hasError: false, error: null, errorInfo: null });
            window.location.href = '/';
          }}
        />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
